<template>
  <!-- 弹窗盒子 -->
  <van-popup
    v-model:show="visible"
    :position="position"
    :close-on-click-overlay="closeOnClickOverlay"
    :overlay-style="resolvedOverlayStyle"
    teleport="body"
    @close="handlePopupClosed"
  >
    <template v-if="hasBackground" #overlay-content>
      <div class="popup-overlay-background">
        <slot name="background"></slot>
      </div>
    </template>
    <div class="popup-view" :style="popupStyle">
      <div v-if="title && title !== null" class="popup-view__header">
        <p class="popup-view__header__title">{{ title }}</p>
      </div>
      <slot v-else name="header"></slot>
      <slot name="content"></slot>
    </div>
    <div v-if="closeable" class="close-container chxy-row-c-c" @click="closePopup">
      <van-icon name="close" size="32" color="#FFFFFF" />
    </div>
  </van-popup>
</template>

<script setup>
const visible = ref(false)
const slots = useSlots()
const props = defineProps({
  title: { type: String, default: '' },
  position: { type: String, default: 'center' },
  closeable: { type: Boolean, default: true },
  closeOnClickOverlay: { type: Boolean, default: false },
  padding: { type: [Number, String], default: 10 },
  radius: { type: [Number, String], default: 15 },
  background: { type: String, default: '' },
  borderSize: { type: [Number, String], default: 1 },
  borderColor: { type: String, default: '' },
  boxShadow: { type: Boolean, default: true },
  overlayStyle: { type: Object, default: null },
})

const hasBackground = computed(() => !!slots.background?.())

const resolvedOverlayStyle = computed(() => {
  if (props.overlayStyle) return props.overlayStyle
  if (hasBackground.value) return { background: 'transparent' }
  return undefined
})

const popupStyle = computed(() => {
  const obj = {
    padding: !isNaN(props.padding) ? `${props.padding}px` : props.padding,
    'border-radius': `${props.radius}px`,
    'border-width': `${props.borderSize}px`,
  }

  if (props.background && props.background !== null && props.background !== '') {
    obj['background'] = props.background
  }
  if (props.borderColor && props.borderColor !== null && props.borderColor !== '') {
    obj['border-color'] = props.borderColor
  }
  if (!props.boxShadow) {
    obj['box-shadow'] = 'none'
  }

  return obj
})

const emit = defineEmits(['close'])

const open = () => {
  visible.value = true
}

/** 仅关闭弹窗；由 van-popup @close 统一向上 emit，避免重复触发 */
const close = () => {
  if (!visible.value) return
  visible.value = false
}

/** van-popup 真正关闭后回调（手动关闭 / 点遮罩都会走这里，且只触发一次） */
const handlePopupClosed = () => {
  emit('close')
}

const openPopupClose = () => {
  open()
}

const closePopup = () => {
  close()
}

defineExpose({ open, close, openPopupClose, closePopup })
</script>

<style scoped lang="less">
.popup-overlay-background {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}
.popup-view {
  position: relative;
  background: var(--popup-primary-background);
  border-style: solid;
  border-color: var(--popup-primary-border);
  box-shadow: inset 0 1px 4px 0 #ffffff30;
  overflow-y: visible;

  &__header {
    width: 100%;
    height: 24px;
    font-size: 16px;
    text-align: center;
    color: var(--popup-primary-title);
    line-height: 24px;
  }
}
.close-container {
  margin-top: 30px;
}
</style>
